'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

import styles from './blog-search.module.css';

interface BlogSearchProps {
  placeholder?: string;
  buttonText?: string;
  buttonColor?: string;
  className?: string;
  isConsumerNews?: boolean;
}

export function BlogSearch({
  placeholder = 'Search posts',
  buttonText = 'Search',
  buttonColor = '#3b82f6',
  className = '',
  isConsumerNews = false,
}: BlogSearchProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();
  const baseUrl = isConsumerNews ? '/consumer-news' : '/partner-news';
  console.log(baseUrl);

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (searchQuery.trim()) {
      // Navigate to search results page with query parameter
      const encodedQuery = encodeURIComponent(searchQuery.trim());
      router.push(`${baseUrl}/search?q=${encodedQuery}`);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const form = e.currentTarget.form;
      if (form) {
        const submitEvent = new Event('submit', {
          bubbles: true,
          cancelable: true,
        });
        form.dispatchEvent(submitEvent);
      }
    }
  };

  return (
    <div className={`${styles.searchContainer} ${className}`}>
      <form onSubmit={handleSearch} className={styles.searchForm}>
        <div className={styles.inputWrapper}>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            className={styles.searchInput}
            aria-label="Search blog posts"
          />
        </div>
        <button
          type="submit"
          className={styles.searchButton}
          style={{ backgroundColor: buttonColor }}
          aria-label="Submit search"
        >
          {buttonText}
        </button>
      </form>
    </div>
  );
}
